/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Minprice1Inputs */

const en_minprice1 = /** @type {(inputs: Minprice1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Min price`)
};

const de_minprice1 = /** @type {(inputs: Minprice1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mindestpreis`)
};

/**
* | output |
* | --- |
* | "Min price" |
*
* @param {Minprice1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const minprice1 = /** @type {((inputs?: Minprice1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Minprice1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_minprice1(inputs)
	return de_minprice1(inputs)
});
export { minprice1 as "minPrice" }